// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ConsentCookieBanner.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ConsentCookieBanner.tsx");
  import.meta.hot.lastModified = "1773385375627.6465";
}
// REMIX HMR END

import { useEffect, useState } from "react";
import { getCookie, setCookie } from "~/utils/utils";
import Button from "./Button";
export default function ConsentCookieBanner() {
  _s();
  const [showBanner, setShowBanner] = useState(false);
  useEffect(() => {
    // Check if cookie consent already exists
    const consentCookie = getCookie("consent_cookies");
    if (!consentCookie) {
      setShowBanner(true);
    }
  }, []);
  const handleConsent = accept => {
    const consentValue = accept ? "granted" : "denied";

    // TODO: Pass the consent as obj to the setCookie function
    // Create the consent object
    // const consentObj = {
    //   consentCookies: {
    //     ad_storage: consentValue,
    //     analytics_storage: consentValue,
    //     ad_user_data: consentValue,
    //     ad_personalization: consentValue,
    //     functionality_storage: consentValue,
    //     personalization_storage: consentValue,
    //     security_storage: consentValue,
    //   },
    // };

    // Set the cookie (365 days)
    setCookie("consent_cookies", consentValue, 365);

    // Update dataLayer if it exists
    if (typeof window !== "undefined" && "dataLayer" in window) {
      window.dataLayer.push(["consent", "update", consentValue]);
      location.reload();
    }

    // Hide the banner
    setShowBanner(false);
  };
  if (!showBanner) return null;
  return <div className="sticky z-20 bottom-8 md:bottom-6 left-0 mx-4 md:mx-6 bg-white max-w-[600px] border border-primary-500 rounded-md p-3">
      <p className="text-sm mb-3 text-neutral-500">
        We use cookies and analytics tools to better understand how you use our
        site and enhance your browsing experience. This helps us make our
        website better for you. You can accept or decline these analytics
        cookies.
      </p>
      <div className="flex gap-3">
        <Button variant="primary" size="sm" onClick={() => handleConsent(true)}>
          Accept
        </Button>
        <Button variant="secondary" size="sm" onClick={() => handleConsent(false)}>
          Decline
        </Button>
      </div>
    </div>;
}
_s(ConsentCookieBanner, "1grwDPkfvitbAJm4HZFczy8eoqw=");
_c = ConsentCookieBanner;
var _c;
$RefreshReg$(_c, "ConsentCookieBanner");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;